import { useEffect, useCallback } from "react"
import { router } from "@inertiajs/react"
import { toast } from "sonner"
import { consumer } from "@/lib/cable"
import { getNotificationMessage } from "@/lib/notification-messages"
import type { AppNotification } from "@/types"

type Options = {
  onNotification?: (notification: AppNotification) => void
}

export function useNotificationChannel({ onNotification }: Options = {}) {
  const handleReceived = useCallback(
    (data: AppNotification) => {
      toast(getNotificationMessage(data.notification_type, data.data))
      router.reload({ only: ["unread_notifications_count"] })
      onNotification?.(data)
    },
    [onNotification],
  )

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: "NotificationChannel" },
      { received: handleReceived },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [handleReceived])
}
